package com.anjuros.website.redesign.sections.trades

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.RdFaqBand
import com.anjuros.website.redesign.util.RdText

/** Trade website questions; also used for the FAQPage structured data. */
val TradesFaqs = listOf(
    RdText.TRADES_FAQ1_Q to RdText.TRADES_FAQ1_A,
    RdText.TRADES_FAQ2_Q to RdText.TRADES_FAQ2_A,
    RdText.TRADES_FAQ3_Q to RdText.TRADES_FAQ3_A,
    RdText.TRADES_FAQ4_Q to RdText.TRADES_FAQ4_A,
)

@Composable
fun TradesFaqSection() {
    RdFaqBand(RdText.TRADES_FAQ_TITLE, TradesFaqs)
}
